import React, { ReactElement } from "react";
import { ReactComponent as OptionArrow } from "./static/icons.svg";
import './InputSelect.css'

interface SelectProps {
    title: string,
    onClickFunc: Function,
    children?: ReactElement,
    isActiveChildren?: boolean,
    disabledStyles?: boolean,
    addHint?: string
}

const InputSelect = ({title = 'Select', onClickFunc, children, isActiveChildren, disabledStyles = false, addHint}: SelectProps) => {

    return (
        <>
            <div style={{display: 'inline-block', maxWidth: '250px'}} title={addHint}>
                <span className={`inputSelect ${isActiveChildren ? 'active' : ''} ${disabledStyles && 'disbledStyles'}`} onClick={(e: any) => {
                    e.stopPropagation()
                    onClickFunc()}}>
                    <p className="inputSelect__title">{title}</p>
                    {
                        !disabledStyles &&
                        <div style={{width: '16px', height: '16px'}}>
                            <OptionArrow className={`inputSelect_logo ${isActiveChildren ? 'active' : ''}`}/>
                        </div>
                    }
                </span>
                {
                    isActiveChildren && 
                    <div className="inputSelect__optionList">
                        {children}
                    </div>
                }
            </div>
        </>
    )

}

export default InputSelect;